import {combineReducers} from 'redux';
import {show_profile} from './reducer';
export default combineReducers({
    show_profile
})